import * as t from 'io-ts';
import { decode } from '../../../server/lib/codec';

const ModelV = t.strict({
  submitted: t.boolean,
  narvarSubmitted: t.boolean,
  hasProfile: t.boolean,
});

async function assertResponseIsOk(response: Response) {
  if (!response.ok) {
    throw Object.assign(new Error('Unexpected Response'), {
      status: response.status,
      text: await response.text(),
    });
  }
}

export async function getLasershipDeliveryInstructions(
  signal: AbortSignal,
  retailerMoniker: string | undefined,
  trackingNumber: string | undefined,
): Promise<t.TypeOf<typeof ModelV> | undefined> {
  if (retailerMoniker === undefined) return undefined;
  if (trackingNumber === undefined) return undefined;

  const resource = `/api/v1/lasership-delivery-instructions/${retailerMoniker}/${trackingNumber}`;
  const response = await fetch(resource, { signal });
  await assertResponseIsOk(response);
  const json = (await response.json()) as unknown;
  return decode(ModelV, json);
}

export async function putLasershipDeliveryInstructions(
  retailerMoniker: string,
  trackingNumber: string,
  orderNumber: string,
  instructions: string,
  sublimeEmail?: string,
): Promise<t.TypeOf<typeof ModelV>> {
  const resource = `/api/v1/lasership-delivery-instructions/${retailerMoniker}/${trackingNumber}`;
  const response = await fetch(resource, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ instructions, orderNumber, sublimeEmail }),
  });
  await assertResponseIsOk(response);
  const json = (await response.json()) as unknown;
  return decode(ModelV, json);
}
